import { FC, useContext, useMemo } from "react";
import { Waffles } from "@app/shared/waffles/Waffles";
import { EcdGenerateReportContext } from "@app/overviews/enterprise-compliance-dashboard/contexts/EcdGenerateReportContext";
import { wafflesKeyColumnName } from "@app/shared/waffles/exports";
import ExceptionsChart from "@app/overviews/enterprise-compliance-dashboard/components/ExceptionsChart";
import { sharedEcdExportDrillInColumnConfig } from "@app/overviews/enterprise-compliance-dashboard/flyouts/EcdDrillInConfig";
import { EcdExceptionsDrillInTableData } from "@app/overviews/enterprise-compliance-dashboard/flyouts/EcdExceptionsFlyout";
import { filterToTimeFrame } from "@app/overviews/enterprise-compliance-dashboard/utility";

const ExceptionsExport: FC = () => {
  const wizardContext = useContext(EcdGenerateReportContext);
  const title = "Exceptions/Justifications";
  const isEmpty = wizardContext.exceptionsData.every((d) => (
    d.exceptionsAppealed === 0 &&
    d.exceptionsApproved === 0 &&
    d.exceptionsDenied === 0 &&
    d.exceptionsPending === 0 &&
    d.exceptionsSubmitted === 0
  ));

  const tableData = !isEmpty ? wizardContext.exceptionsDrillInData.map((row) => {
    return {
      /* oxlint-disable sort-keys */
      [wafflesKeyColumnName]: row.customProjectId.toString(),
      projectName: <span>{row.projectName}</span>,
      approved: row.exceptionsApproved.toLocaleString(),
      pending: row.exceptionsPending.toLocaleString(),
      submitted: row.exceptionsSubmitted.toLocaleString(),
      appealed: row.exceptionsAppealed.toLocaleString(),
      denied: row.exceptionsDenied.toLocaleString(),
      /* oxlint-enable sort-keys */
    }
  }) : [];

  const slicedExceptionsData = useMemo(() => {
    return filterToTimeFrame(wizardContext.exceptionsData, wizardContext.exceptionsTimeFrame);
  }, [wizardContext.exceptionsData, wizardContext.exceptionsTimeFrame]);

  //cut off array when rows will exceed one page in export
  if (tableData.length > 15)
    tableData.length = 15;

  return (
    <div className="ecd-export__wrapper">
      <div style={{ display: "flex" }}>
        <h2 className="qes-dashboard-tile__title ecd-export__head">{title}</h2>
        <h2 className="qes-dashboard-tile__title ecd-export__head" style={{ marginLeft: "auto", order: "2" }}>{"Time Frame: " + wizardContext.exceptionsTimeFrame}</h2>
      </div>
      <ExceptionsChart
        data={slicedExceptionsData}
        timeFrame={wizardContext.exceptionsTimeFrame}
        exceptionsArray={wizardContext.exceptionsArray}
        isExport={true}
      />
      <br />
      {(wizardContext.addGraphDetails && !isEmpty) && (
        <div className="ecd-export__table">
          <h2 className="qes-dashboard-tile__title ecd-export__head">{title + " Details"}</h2>
          <Waffles<EcdExceptionsDrillInTableData>
            columns={sharedEcdExportDrillInColumnConfig}
            data={tableData}
            fullWidth={true}
            loading={tableData.length === 0}
            testId="ecd-exceptions-flyout__table"
            />
        </div>
      )}
    </div>
  );
}

export default ExceptionsExport;